<template>
 <v-container grid-list-md>
  <v-layout wrap>
    <v-flex xs12>
      <v-card>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 sm4>
              <v-text-field label="Title" v-model="category.title" required></v-text-field>
            </v-flex>
            
            <v-flex xs12 sm4>
              <v-text-field label="Category" v-model="category.category" required></v-text-field>
            </v-flex>

            <v-flex xs12 sm4>
              <v-text-field label="Url" v-model="category.url" required></v-text-field>
            </v-flex>

            <v-flex xs12 sm4>
              <v-text-field label="H1 Title" v-model="category.h1_title"></v-text-field>
            </v-flex>

            <v-flex xs12>
              <ckeditor v-model="category.description" id="description"
                data-vv-name="description"  label="Description" :editor="editor" :config="editorConfig"></ckeditor>
            </v-flex>

            <v-flex xs12>
               <v-divider></v-divider>
            </v-flex>
            
            <v-flex xs12 sm6>
              <div class="subheading" v-for="(item, i) in category.subcategories" :key="i">
                <v-btn small flat>{{ i+1 }}. {{ item }}</v-btn>
                <v-btn @click="remove(i)" small flat icon class="right warning--text">
                  <v-icon>cancel</v-icon>
                </v-btn>
              </div>
            </v-flex>

            <v-flex xs12>
            <v-btn @click="openSubModal()" flat class="primary--text">
              <v-icon left>add</v-icon>Add sub category
            </v-btn>
            <!-- <v-btn flat class="primary--text"> <v-icon left>add</v-icon> Add subpage </v-btn> -->
            <v-dialog v-model="dialog" persistent max-width="500">
              <v-card>
                <v-card-title class="title">Add sub category</v-card-title>

                <v-card-text>
                  <v-layout wrap v-if="dialog">
                    <v-flex class="pa-1" xs12 sm12>
                      <v-text-field label="Sub category" v-model="sub.name" required></v-text-field>
                    </v-flex>

                  </v-layout>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="purple darken-1" flat @click.native="dialog = false">Cancel</v-btn>
                  <v-btn color="purple darken-1" flat @click="addSub">Add</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-flex>


            <v-flex xs12 class="text-xs-right mt-3">
              <v-btn class="primary" :loading="loader" @click="saveData" type="submit" flat>
                <v-icon left>save</v-icon>Save
              </v-btn>
            </v-flex>
          </v-layout>
         
        </v-card-text>
        <v-card-actions></v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
  </v-container>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditor from '@ckeditor/ckeditor5-vue2';

export default {
  name: "CategoryEditorComponent",
  components: {
    CKEditor,
  },
  props: {
    loading: {
      required: true,
      type: Boolean,
      default: false
    },
    initial: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      loader: false,
      dialog: false,
      sub: {},
      category: { parent: false, subcategories: [] },
      editor: ClassicEditor,
      editorConfig: {
        image: {
            styles: [
                'alignLeft', 'alignCenter', 'alignRight'
            ],
            resizeOptions: [
                {
                    name: 'imageResize:original',
                    label: 'Original',
                    value: null
                },
                {
                    name: 'imageResize:50',
                    label: '50%',
                    value: '50'
                },
                {
                    name: 'imageResize:75',
                    label: '75%',
                    value: '75'
                }
            ],
            toolbar: [
                'imageStyle:alignLeft', 'imageStyle:alignCenter', 'imageStyle:alignRight',
                '|',
                'imageResize',
                '|',
                'imageTextAlternative',
                '|',
                'linkImage'
            ]
        },
        link: { addTargetToExternalLinks: true },
      },
    };
  },
  methods: {
    openSubModal(){
      this.dialog = true;
    },
    addSub() {
      //  console.log('adding sub')
      const name = this.sub.name;
      if (name !== "") {
        this.category.subcategories.push(name);
        this.sub = {};
        this.dialog = false;
      }
    },
    remove(i) {
      this.category.subcategories.splice(i, 1);
    },
    resetLoading(val) {
      this.loader = val
    },
    setCategory(val) {
      const category = this.category;
      this.category = { ...category, ...val };
    },
    saveData() {
      const self = this;
      this.$validator.validateAll().then(isValid => {
        self.$emit("data", self.category);
      });
    }
  },
  watch: {
    initial: {
      handler: "setCategory",
      immediate: true
    },
    loading: {
      handler: "resetLoading",
      immediate: false
    }
  }
};
</script>